import React from "react"
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image"
import Link from "../link"
import Button from "../../ui/button"
import GraduateCapIconSolid from "../icons/graduate-cap-icon-solid"
import ChartIconSolid from "../icons/chart-icon-solid"

type LearningPathCardProps = {
  title: string
  cover: IGatsbyImageData
  slug: string
  steps: string
}
const LearningPathCard = ({
  title,
  cover,
  slug,
  steps,
}: LearningPathCardProps) => {
  return (
    <Link to={`/premium/paths/${slug}/`} external className="snap-center">
      <div className="flex flex-col rounded-2xl	border border-neutral-alpha-4">
        <div className="w-[328px] lg:w-full h-[163px]">
          {cover ? (
            <GatsbyImage
              image={getImage(cover) || cover}
              alt={title}
              className="rounded-t-2xl w-full h-[118px]"
            />
          ) : (
            <div className="bg-neutral-3 h-full w-full flex items-center justify-center rounded-t-lg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="88"
                height="88"
                viewBox="0 0 88 88"
                fill="none"
              >
                <path
                  d="M68.2 74.8C65.6944 74.8 63.4944 74.0667 61.6 72.6C59.7055 71.1333 58.4222 69.3 57.75 67.1H36.3C32.9389 67.1 30.0819 65.9236 27.7292 63.5708C25.3764 61.2181 24.2 58.3611 24.2 55C24.2 51.6389 25.3764 48.782 27.7292 46.4292C30.0819 44.0764 32.9389 42.9 36.3 42.9H47.3C49.4175 42.9 51.2302 42.1438 52.7381 40.6314C54.246 39.1191 55 37.301 55 35.1773C55 33.0535 54.246 31.2431 52.7381 29.7458C51.2302 28.2486 49.4175 27.5 47.3 27.5H30.25C29.5778 29.7 28.2944 31.5333 26.4 33C24.5055 34.4667 22.3055 35.2 19.8 35.2C16.7444 35.2 14.1472 34.1306 12.0083 31.9917C9.86943 29.8528 8.79999 27.2556 8.79999 24.2C8.79999 21.1445 9.86943 18.5472 12.0083 16.4083C14.1472 14.2695 16.7444 13.2 19.8 13.2C22.3055 13.2 24.5055 13.9333 26.4 15.4C28.2944 16.8667 29.5778 18.7 30.25 20.9H47.3C51.2722 20.9 54.6486 22.2903 57.4292 25.0708C60.2097 27.8514 61.6 31.2278 61.6 35.2C61.6 39.1722 60.2097 42.5486 57.4292 45.3292C54.6486 48.1097 51.2722 49.5 47.3 49.5H36.3C34.7875 49.5 33.4927 50.0401 32.4156 51.1204C31.3385 52.2007 30.8 53.4993 30.8 55.0162C30.8 56.5332 31.3385 57.8264 32.4156 58.8958C33.4927 59.9653 34.7875 60.5 36.3 60.5H57.75C58.4222 58.3 59.7055 56.4667 61.6 55C63.4944 53.5333 65.6944 52.8 68.2 52.8C71.2555 52.8 73.8528 53.8695 75.9917 56.0083C78.1305 58.1472 79.2 60.7445 79.2 63.8C79.2 66.8556 78.1305 69.4528 75.9917 71.5917C73.8528 73.7306 71.2555 74.8 68.2 74.8ZM19.8 28.6C21.0467 28.6 22.0917 28.1783 22.935 27.335C23.7783 26.4917 24.2 25.4467 24.2 24.2C24.2 22.9533 23.7783 21.9083 22.935 21.065C22.0917 20.2217 21.0467 19.8 19.8 19.8C18.5533 19.8 17.5083 20.2217 16.665 21.065C15.8217 21.9083 15.4 22.9533 15.4 24.2C15.4 25.4467 15.8217 26.4917 16.665 27.335C17.5083 28.1783 18.5533 28.6 19.8 28.6Z"
                  fill="#D3D4DB"
                />
              </svg>
            </div>
          )}
        </div>
        <div className="flex flex-col gap-4 rounded-2xl -mt-24 z-50 bg-white h-full">
          <div className="flex flex-col gap-4 px-4 pt-4">
            <div>
              <div className="text-jar-4 font-medium text-neutral-12 line-clamp-1">
                {title}
              </div>
              <p className="text-jar-3 line-clamp-2 mt-1">
                Learn JavaScript, the language of the web. Then deep dive into
                some popular frontend and backend JavaScript frameworks and
                start your Full Stack career the right way.
              </p>
              <div className="flex items-center gap-1.5 mt-3">
                <GraduateCapIconSolid className="size-5" />
                <span className="text-jar-3 text-neutral-11">Beginner</span>
                <span className="text-jar-3 text-neutral-11">·</span>
                <ChartIconSolid className="size-5" />
                <span className="text-jar-3 text-neutral-11">
                  {steps} steps
                </span>
              </div>
            </div>
          </div>
          <div className="pb-5 px-4">
            <Button
              variant="soft"
              theme={"neutral"}
              size={3}
              className="w-full"
            >
              Start Learning
            </Button>
          </div>
        </div>
      </div>
    </Link>
  )
}

export { LearningPathCard }
